// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"223":"9795f510","236":"de2cf15f","289":"50230384","295":"e1fc117a","454":"01fbdf0e","656":"1e809524","670":"ee174e7a"}[chunkId] + ".chunk.css";
};